var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"mondays-view-frame",attrs:{"src":"https://view.monday.com/embed/1888763354-97f92c86ab0782061ba1b019f26276c9?r=use1"}})}
var staticRenderFns = []

export { render, staticRenderFns }